import { CustomMeetYourHerbsState } from "@gaiaProfessionals/Store/MeetYourHerbs/GAIAMeetYourHerbsReducer";
import translate from "@insite/client-framework/Translate";
import { WidgetGroup } from "@insite/client-framework/Types/WidgetGroups";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: CustomMeetYourHerbsState) => {
    const product = state.customMeetYourHerbsReducer?.product;
    return {
        masterId: product?.cofc.master_id,
        manufacturedDate: product?.manufactured_date,
        bestBy: product?.cofc.best_by,
    };
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export interface ProductDetailsPartNumberStyles {
    labelText?: TypographyProps;
    valueText?: TypographyProps;
}

export const partNumberStyles: ProductDetailsPartNumberStyles = {
    labelText: {
        size: 15,
        fontFamily: "LatoBold",
        css: css`
            margin-right: 5%;
            min-width: 175px;
        `,
    },
    valueText: {
        size: 15,
        fontFamily: "Lato",
        css: css`
            display: flex;
            padding: 8px 0px;
            border-bottom: 1px solid #ccc;
            &:last-child {
                border-bottom: none;
            }
        `,
    },
};

const styles = partNumberStyles;

const GAIAMYHProductDetailsPartNumber: React.FC<Props> = ({ manufacturedDate, masterId, bestBy }) => {
    if (!manufacturedDate && !masterId && !bestBy) {
        return null;
    }

    return (
        <>
            {manufacturedDate && (
                <Typography {...styles.valueText} as="p">
                    <Typography {...styles.labelText} as="p">
                        {translate("Master Id")}
                    </Typography>
                    <Typography>{masterId}</Typography>
                </Typography>
            )}
            {manufacturedDate && (
                <Typography {...styles.valueText} as="p">
                    <Typography {...styles.labelText}>{translate("Manufactured Date")}</Typography>
                    {manufacturedDate}
                </Typography>
            )}
            {bestBy && (
                <Typography {...styles.valueText} as="p">
                    <Typography {...styles.labelText}>{translate("Best By Date")}</Typography>

                    {bestBy}
                </Typography>
            )}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(GAIAMYHProductDetailsPartNumber),
    definition: {
        displayName: "MYH Part Number",
        group: "MYH Product Details" as WidgetGroup,
    },
};

export default widgetModule;
